export const FAIL_ERROR_CODE_EXISTS = 'account_already_exists';
export const FAIL_ERROR_CODE_LOCKED = 'Account is locked';

export const FAIL_REASON_NOT_FOUND = 'FAIL_REASON_NOT_FOUND';
export const FAIL_REASON_LOCKED = 'FAIL_REASON_LOCKED';
export const FAIL_REASON_ALREADY_EXISTS = 'FAIL_REASON_ALREADY_EXISTS';

export const ACTION_FORGOT_PASSWORD_RESET = 'AUTH/ACTION_FORGOT_PASSWORD_RESET';
export const ACTION_FORGOT_PASSWORD_REQUEST = 'AUTH/ACTION_FORGOT_PASSWORD_REQUEST';
export const ACTION_REGISTER_RESET = 'AUTH/ACTION_REGISTER_RESET';
export const ACTION_REGISTER_REQUEST = 'AUTH/ACTION_REGISTER_REQUEST';
export const ACTION_REMEMBER_ME_CHANGE = 'AUTH/ACTION_REMEMBER_ME_CHANGE';

export const ACTION_RESET_PASSWORD_RESET = 'AUTH/ACTION_RESET_PASSWORD_RESET';
export const ACTION_RESET_PASSWORD_REQUEST = 'AUTH/ACTION_RESET_PASSWORD_REQUEST';



// WEBPACK FOOTER //
// ./src/auth/constants.js